import React from 'react';
import {CheckRoute} from "../../routesConstants";
import numberFormat from "../../../helpers/numberFormat";

const UndefinedTransactionsBlock = ({data, period}) => {
  return (
    <b className={'d-flex justify-content-around p-3 pointer'}
       style={{backgroundColor: 'rgba(255,71,71,0.35)'}}
       onClick={() => {
         localStorage.setItem('otherQuery', JSON.stringify({startDate: period.start, endDate: period.end}))
         window.open(CheckRoute)
       }}
    >
      <div>Нераспознанные транзакции на сумму:</div>
      {data.map((summ, i) => {
        if (summ.total !== 0) {
          return <div key={i}>{numberFormat(summ.total)} {summ.currency}</div>
        }
      })}
    </b>
  );
};

export default UndefinedTransactionsBlock;
